import ApiBase, { baseUrl } from '.';

export default class CourseServiceApi extends ApiBase {
  constructor(token) {
    super(`${baseUrl}/api/services/app/CourseService`, token);
  }

  getCourses(name = '', skipCount = 0, maxResultCount = 10) {
    return this.authHttp.get(`${this.baseUrl}/GetCourses`, {
      params: {
        Name: name,
        SkipCount: skipCount,
        MaxResultCount: maxResultCount
      }
    });
  }

  getWithSubmodules(courseId) {
    return this.authHttp.get(`${this.baseUrl}/GetWithSubmodules`, {
      params: { courseId: courseId }
    });
  }

  update(version) {
    return this.authHttp.put(`${this.baseUrl}/Update`, version);
  }

  finishEditing(id) {
    return this.authHttp.post(
      `${this.baseUrl}/FinishEditing`,
      {},
      {
        params: {
          id: id
        }
      }
    );
  }

  create(course) {
    return this.authHttp.post(`${this.baseUrl}/Create`, course);
  }

  delete(id) {
    return this.authHttp.delete(`${this.baseUrl}/Delete`, {
      params: { id: id }
    });
  }

  copy(courseId, name) {
    return this.authHttp.post(`${this.baseUrl}/Copy`, { courseId, name });
  }

  simpleUpdate(id, name, isActive) {
    return this.authHttp.put(`${this.baseUrl}/SimpleUpdate`, {
      id,
      name,
      isActive
    });
  }
}
